<button type="button" mat-icon-button color="primary">
    <mat-icon>close</mat-icon>
  </button>
